import { Box, Button, ButtonRow } from '@ksyos/design-system';
import { useTheme } from 'styled-components';
import type { IServiceStartingPoint } from '@common/interfaces';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { getServiceData } from '../../data/getServiceData';
import { ServiceCardContent } from '../serviceCards/ServiceCardContent';
import { ServiceTooltip } from '../serviceCards/serviceTooltip';

type StartingPointCardWithStartButtonProps = {
    isSelected: boolean;
    onClick: (startingPoint: IServiceStartingPoint, service: ServiceForSelectedServiceType) => void;
    service: ServiceForSelectedServiceType;
    startingPoint: IServiceStartingPoint;
};

export function StartingPointCardWithStartButton(props: Readonly<StartingPointCardWithStartButtonProps>) {
    const theme = useTheme();

    const { isSelected, onClick, service, startingPoint } = props;
    const itemData = getServiceData(service, startingPoint);

    const { buttonText, order } = itemData;

    const { code, reason, unavailableForPatient: isUnavailableForPatient } = service;

    const disabledStyles = {
        '&:hover': {
            color: theme.colors.neutral500,
            // eslint-disable-next-line sort-keys
            '&:before': {
                background: 'transparent',
            },
        },
    };

    return (
        <Box
            backgroundColor="white"
            borderRadius="base"
            boxShadow="base"
            key={startingPoint.label}
            order={order}
            p={6}
            pt={5}
            style={{ position: 'relative' }}
        >
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="space-between"
            >
                <ServiceCardContent data={itemData} />

                <ButtonRow
                    justify="right"
                    sx={{ mt: 4 }}
                >
                    <Button
                        color="secondary"
                        data-automation-test={`start-${startingPoint.label}`}
                        id={`${startingPoint.label}`}
                        isDisabled={isUnavailableForPatient}
                        onClick={() => onClick(startingPoint, service)}
                        sx={isUnavailableForPatient && disabledStyles}
                        variant={isSelected ? 'solid' : 'outline'}
                    >
                        <Box sx={{ pointerEvents: 'all' }}>
                            {buttonText}
                            <ServiceTooltip
                                reason={reason}
                                serviceCode={code}
                            />
                        </Box>
                    </Button>
                </ButtonRow>
            </Box>
        </Box>
    );
}
